import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Button, Icon } from 'react-wot-bootstrap'
import { hideTooltip, REWARD_PACK_TYPE, showItemTooltip } from 'helpers/web_to_client'

import Clan from 'components/Clan/Clan'
import { playCongratulationClanJoiningSound } from 'state/actions/sounds'
import {
    BUTTON_BACK_TO_HANGAR,
    SUCCESS_SCREEN_GREETING,
    SUCCESS_SCREEN_MESSAGE,
    WAITING_SCREEN_INFO,
    WAITING_SCREEN_MESSAGE,
    SUCCESS_SCREEN_AWARD_MESSAGE,
} from './translations'
import { requestGreetingLandingInfo } from 'state/actions/greeting_landing'
import { AFFIRMATIVE } from 'containers/WGCWXShop/translations'

import styles from './LandingResult.scss'

const LandingResult = ({ isWaiting, onClick }) => {
    const tooltipTimeoutRef = useRef(0)
    const dispatch = useDispatch()
    const { greetingLanding } = useSelector(state => state)

    useEffect(() => {
        playCongratulationClanJoiningSound()
        dispatch(requestGreetingLandingInfo())
    }, [])

    const handleMouseEnter = () => {
        tooltipTimeoutRef.current = window.setTimeout(() => {
            showItemTooltip(REWARD_PACK_TYPE.STYLE_ALL, 1, parseInt(199, 10) || '')
            tooltipTimeoutRef.current = undefined
        }, 200)
    }

    const handleMouseLeave = () => {
        window.clearTimeout(tooltipTimeoutRef.current)
        if (tooltipTimeoutRef.current === undefined) {
            hideTooltip()
        }
    }

    return (
        <div className={cx(styles.base, isWaiting && styles.base__waiting)}>
            <div className={styles.greeting}>{SUCCESS_SCREEN_GREETING}</div>
            <div className={styles.message}>{isWaiting ? WAITING_SCREEN_MESSAGE : SUCCESS_SCREEN_MESSAGE}</div>
            <Clan {...greetingLanding} className={styles.clan} nameColor="#fefeec" />
            <div className={styles.awardContainer}>
                <div className={styles.awardImage} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
            </div>
            <div className={styles.awardMessage}>{SUCCESS_SCREEN_AWARD_MESSAGE}</div>
            <div className={styles.info}>
                <span className={styles.warningIcon}>
                    <Icon glyph="warning" />
                </span>
                {WAITING_SCREEN_INFO}
            </div>
            <Button isExternal onClick={onClick} tooltipId="style_tooltip" mixClassName={styles.button}>
                {isWaiting ? BUTTON_BACK_TO_HANGAR : AFFIRMATIVE}
            </Button>
        </div>
    )
}

LandingResult.propTypes = {
    isWaiting: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    playCongratulationClanJoiningSound: PropTypes.func,
}

export default LandingResult



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingResult/LandingResult.jsx